import { useCallback } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from '../../../react-redux';
import { getMarketingStatus, setLoading, getTicketStatus } from '../../../reducers/marketing-status';

import { getMarketingInfoApi, getTicketInfoApi } from '../api/index';
import { isHiddenFn } from '@/utils/bespoke-config/config';

const initData = {
  agent: {},
  call: {},
  expire_time: '',
  has_expired: true,
  history_order_cnt: 0,
  mpush_robot: {},
  package: [],
  plan: 0,
  plan_name: '',
  pre_plan: 0,
  pre_plan_name: '',
  push: {},
  robot: {},
  seat: 1,
  seconds_left: 0,
  ticket: {},
  trial_status: 16,
  overflowed_traffic: 1,
  balance: 0
};

const useMarketingStatus = () => {
  const dispatch = useDispatch();
  const marketingInfo = useSelector(state => state.getIn(['marketingStatus', 'data']));
  const ticketInfo = useSelector(state => state.getIn(['marketingStatus', 'ticket']));
  const loading = useSelector(state => state.getIn(['marketingStatus', 'loading']));
  const handleGetMarketingStatus = useCallback(() => {
    dispatch(setLoading(true));

    getMarketingInfoApi()
      .then(res => {
        dispatch(getMarketingStatus({ ...initData, ...res.data }));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  }, []);

  const handleGetTicketInfo = useCallback(() => {
    if (isHiddenFn('notification_ticket_api')) {
      return;
    }
    getTicketInfoApi().then(res => {
      dispatch(getTicketStatus(res?.data?.data || {}));
    });
  }, []);

  const isAgentPayed = () => {
    const { agent } = marketingInfo;
    const agentExpireTime = moment(moment.utc(agent?.agent_expire_at).toDate());
    // 剩余时间
    const agentLeftTime = agentExpireTime.diff(moment(), 's');
    var isAgentPay = agentLeftTime > 0 && agent.agent_plan !== 1002;
    // 判断老版本
    if (!isAgentPay) {
      isAgentPay = marketingInfo?.plan > 1;
    }
    return isAgentPay;
  };

  const isCallPayed = () => {
    const { call } = marketingInfo;
    return call?.call_agent_quantity > 0;
  };

  const isCallRobotPayed = () => {
    const { call_robot } = marketingInfo;
    return call_robot?.call_robot_plan > 0;
  };

  const isPushRobotPayed = () => {
    const { mpush_robot } = marketingInfo;
    return mpush_robot?.plan > 1101;
  };

  const isAgentRobotPayed = () => {
    const { robot } = marketingInfo;
    return robot?.robot_plan > 0;
  };

  const isTicketPayed = () => {
    const { new_ticket } = marketingInfo;
    const newTicketExpireTime = moment(moment.utc(new_ticket?.new_ticket_expire_at).toDate());
    const newTicketLeftTime = newTicketExpireTime.diff(moment(), 's');
    const new_ticket_plan = new_ticket?.new_ticket_plan;
    return newTicketLeftTime > 0 && new_ticket_plan !== 1502; // 1502 是体验版
  };

  const isAgentProPlan = () => {
    const { agent } = marketingInfo;
    const isAgentProPlan = agent.agent_plan == 1003; // 专业版
    return isAgentProPlan;
  };

  const isPayAnyPayed = () => {
    return (
      isAgentPayed() ||
      isCallPayed() ||
      isCallRobotPayed() ||
      isPushRobotPayed() ||
      isTicketPayed() ||
      isAgentRobotPayed()
    );
  };

  const insNotPayed = () => {
    return (
      !isAgentPayed() &&
      !isCallPayed() &&
      !isCallRobotPayed() &&
      !isPushRobotPayed() &&
      !isTicketPayed() &&
      !isAgentRobotPayed()
    );
  };

  const isDisableIframe = () => {
    const path = window.location.pathname;
    let isAgentPage = path.includes('/chat') || path.includes('/history');
    if (isAgentPage) {
      return !isAgentPayed() || (isAgentPayed() && isAgentProPlan());
    }
    let isTicketPage = path.includes('/leaveMsg');
    if (isTicketPage && isTicketPayed()) {
      return false;
    }
    let isCallPage = path.includes('/call');
    if (isCallPage && isCallPayed()) {
      return false;
    }
    return true;
  };

  return {
    marketingInfo,
    handleGetMarketingStatus,
    loading,
    ticketInfo,
    handleGetTicketInfo,
    isAgentPayed,
    isCallPayed,
    isCallRobotPayed,
    isPushRobotPayed,
    isTicketPayed,
    isPayAnyPayed,
    insNotPayed,
    isDisableIframe
  };
};

export default useMarketingStatus;
